export class Reward {
    constructor(
        public id: number = 0,
        public description: string = '',
        public amountPoints: number = 0,
        public date: Date | string = new Date()
    ) { }
}
